interface Report {
  id: string;
  reporterId: string;
  reporterUsername?: string | null;
  reason: string;
  category: string;
  details: string | null;
  createdAt: string;
  assignedModeratorId: string | null;
  assignedModeratorUsername?: string | null;
}

interface Props {
  reports: Report[];
}

export default function ReportSidebar({ reports }: Props) {
  return (
    <aside className="Moderation__ModalSidebar">
      <div className="Moderation__ModalSidebar__Title">
        {reports.length} open report{reports.length === 1 ? '' : 's'}
      </div>
      <div className="Moderation__ModalSidebar__Stack">
        {reports.map((r) => (
          <div key={r.id} className="Moderation__ReportCard">
            <div className="Moderation__ReportCard__Header">
              <span
                className={`Moderation__Chip Moderation__Chip--${r.category}`}
              >
                {r.category}
              </span>
              <strong>{r.reason}</strong>
            </div>
            <div className="Moderation__ReportCard__Meta">
              by @{r.reporterUsername ?? r.reporterId} ·{' '}
              {new Date(r.createdAt).toLocaleString()}
            </div>
            {r.details && (
              <div className="Moderation__ReportCard__Details">{r.details}</div>
            )}
            <div className="Moderation__ReportCard__Assignee">
              Assignee:{' '}
              {r.assignedModeratorUsername
                ? `@${r.assignedModeratorUsername}`
                : r.assignedModeratorId
                  ? `@${r.assignedModeratorId}`
                  : 'unassigned'}
            </div>
            {/* Plan D per-report footer slot */}
            <footer className="Moderation__ReportCard__Footer" />
          </div>
        ))}
      </div>
      {/* Plan D post-level verdict action bar slot */}
      <div
        className="Moderation__ModalSidebar__VerdictBar"
        data-testid="verdict-bar-slot"
      />
    </aside>
  );
}
